"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Application.module.css"));
var react_1 = require("react");
var ApplicationInformation_1 = require("./parts/ApplicationInformation");
var ReferralList_1 = require("./parts/Referrals/ReferralList");
var EmploymentList_1 = require("./parts/EmploymentList");
var MilitaryService_1 = require("./parts/MilitaryService");
var SignatureBox_1 = require("./parts/SignatureBox");
var Education_1 = require("./parts/Education");
var mobx_react_1 = require("mobx-react");
var Application = (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Application.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Application.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Application.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction(this.constructor.name);
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Application.prototype.render = function () {
        var model = this.props.model;
        console.log("RENDER Application:");
        console.log(JSON.stringify(this.json_data));
        return (React.createElement("div", null,
            React.createElement("header", { className: styles.header },
                React.createElement("h1", null, "Barber Tech Academy Student Application")),
            React.createElement(ApplicationInformation_1.ApplicationInformation, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(Education_1.Education, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(ReferralList_1.ReferralList, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement("div", { className: styles.newPage }),
            React.createElement(EmploymentList_1.EmploymentList, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(MilitaryService_1.MilitaryService, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(SignatureBox_1.SignatureBox, { model: model })));
    };
    Application = __decorate([
        mobx_react_1.observer
    ], Application);
    return Application;
}(react_1.Component));
exports.Application = Application;
//# sourceMappingURL=data:application/json;base64,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